import React, { useState } from 'react';

import { Badge, Button, Flex, Modal, Tooltip, Typography } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

interface LeedbucksRatesModalButtonProps {
    label: string;
    title: string;
    isModified?: boolean; // changed in the modal but not saved yet
    children: React.ReactNode;
}

export default function LeedbucksRatesModalButton({ label, title, isModified = false, children }: LeedbucksRatesModalButtonProps) {
    const [open, setOpen] = useState(false);

    return <>
        <Tooltip title={isModified ? 'Modifications non sauvegardées' : undefined}>
            <Badge dot={isModified}>
                <Button icon={<SettingOutlined />} onClick={() => setOpen(true)}>{label}</Button>
            </Badge>
        </Tooltip>
        <Modal
            title={title}
            open={open}
            onCancel={() => setOpen(false)}
            width={900}
            footer={<Flex justify="space-between" align="center">
                <Typography.Text type="secondary">Les changements s'appliquent à l'enregistrement du formulaire</Typography.Text>
                <Button type="primary" onClick={() => setOpen(false)}>Fermer</Button>
            </Flex>}
        >
            {children}
        </Modal>
    </>;
}